export default "__VITE_ASSET__616dae48__"